export default {
    allow_to_make_payment_in_insurance_visits: "Sığorta səfərlərində əlavə ödəniş etməyə icazə ver",
    insurance_companies: "Sığorta şirkətləri",
    insurance_polis: "Sığorta polisi",
    limit: "Limit",
    number: "Nömrə",
    paid_by_insurance: "Sığorta tərəfindən ödənilib",
    paid_by_patient: "Xəstə tərəfindən ödənilib",
    polis: "Polis",
    polises: "Polislər",
    use_custom_prices_for_insurance: "Sığorta şirkətləri üçün fərdi qiymətlərdən istifadə et",
    use_only_in_insurance: "Yalnız sığorta üçün istifadə et",
    valid_from: "Nə vaxtdan etibarlıdır",
    valid_to: "Nə vaxta qədər etibarlıdır",
    visit_should_have_polis_set_in_order_to_use_insurance_payment: "Sığorta ödənişindən istifadə etmək üçün səfərin tamamlanmış sığorta polisi olmalıdır",
}
